module.exports = __webpack_public_path__ + "img/user.e1659363.png";